<template>
<!--  用户协议、私隐政策-->
  <div id="agreement">
    <navBan v-if="isMobilePlatform()" :title="navTitle"></navBan>
  </div>
</template>

<script setup>
import { onMounted, computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import navBan from '@/components/navBan';
import { isMobilePlatform } from '@/utils/common';

const paddingTop = computed(() => {
  return isMobilePlatform() ? '44px' : 0;
});
let navTitle = ref('');

const route = useRoute();
function createIframe () {
  navTitle.value = route.query.title;
  const iframe = document.createElement('iframe');
  iframe.src = route.query.link;
  iframe.style = 'border: none; width: 100%; height: 100%';
  const agreement = document.getElementById('agreement');
  agreement.appendChild(iframe);
  iframe.onload = () => {};
}

onMounted(() => {
  createIframe();
});
</script>

<style lang="scss" scoped>
#agreement {
  // padding-top: v-bind(paddingTop);
  padding-top: 0;
  height: 100vh;
  width: 100vw;
}
</style>
